<template>
<div class="grid">

<template v-if="loading">
  <div class="col-12">
<FrameOverlay></FrameOverlay>
</div>
</template>

<template v-else>
 <template v-if="projectsuppliers.length">
   <SupplierDashboardProject v-for="projectsupplier in projectsuppliers" :projectsupplier="projectsupplier">
     
   </SupplierDashboardProject>
 </template>
 <template v-else>
   
 </template>

</template>





</div>
</template>

<script>
import SupplierDashboardProject from "./SupplierDashboardProject"
export default {

  name: 'SupplierDashboardProjects',
  props:["supplier"],
  data () {
    return {
    	projectsuppliers:[],
    	loading:true,
    }
  },
  components:{SupplierDashboardProject},
  mounted()
  {
  	this.getData()
  },
  methods:{
  	async getData()
  	{
      this.loading = true
  		this.projectsuppliers = await this.generalApiGet("supplier_brand_projects_for_dashboard/"+this.supplier.id+"/"+this.supplier.brand.id) 
  		console.log("projectsuppliers")
      console.log(this.projectsuppliers)
      this.loading = false
  	},
  }
}
</script>

<style lang="css" scoped>
</style>